import { z } from 'zod'
import { pageCursorSchema } from '../helpers/page-cursor.js'
import { uuidSchema } from '../validators/params.js'

/**
 * Searching the request log: by request id (exact), path (contains), status
 * (an exact code like `404` or a class like `4xx`), or key.
 */
export const apiRequestQuerySchema = z
  .object({
    requestId: z.string().trim().min(1).max(100).optional(),
    path: z.string().trim().min(1).max(500).optional(),
    status: z
      .string()
      .trim()
      .regex(/^[1-5](?:\d\d|xx)$/, 'Use a status like 404 or a class like 4xx')
      .optional(),
    keyId: uuidSchema.optional(),
    /** A previous page's `nextBefore`. */
    before: pageCursorSchema.optional(),
  })
  .strict()

export type ApiRequestQuery = z.infer<typeof apiRequestQuerySchema>
